import { Company } from '../types';

// Mock data para empresas
const mockCompanies: Company[] = [
  { id: '1', name: 'Petrobras', symbol: 'PETR4', isWatching: true },
  { id: '2', name: 'Vale', symbol: 'VALE3', isWatching: true },
  { id: '3', name: 'Ambev', symbol: 'ABEV3', isWatching: true },
  { id: '4', name: 'Itaú Unibanco', symbol: 'ITUB4', isWatching: false },
  { id: '5', name: 'Bradesco', symbol: 'BBDC4', isWatching: false },
  { id: '6', name: 'Magazine Luiza', symbol: 'MGLU3', isWatching: false },
  { id: '7', name: 'Weg', symbol: 'WEGE3', isWatching: false },
  { id: '8', name: 'JBS', symbol: 'JBSS3', isWatching: false },
  { id: '9', name: 'Vale', symbol: 'VALE3', isWatching: false },
  { id: '10', name: 'Petrobras', symbol: 'PETR4', isWatching: false }
];

export const companyService = {
  // Buscar todas as empresas
  getAllCompanies: async (): Promise<Company[]> => {
    await new Promise(resolve => setTimeout(resolve, 300));
    return [...mockCompanies];
  },

  // Buscar empresas que o usuário está monitorando
  getWatchedCompanies: async (): Promise<Company[]> => {
    await new Promise(resolve => setTimeout(resolve, 200));
    return mockCompanies.filter(company => company.isWatching);
  },

  // Adicionar empresa aos favoritos
  addToWatchlist: async (companyId: string): Promise<boolean> => {
    await new Promise(resolve => setTimeout(resolve, 200));
    const companyIndex = mockCompanies.findIndex(company => company.id === companyId);
    if (companyIndex !== -1) {
      mockCompanies[companyIndex].isWatching = true;
      return true;
    }
    return false;
  },

  // Remover empresa dos favoritos
  removeFromWatchlist: async (companyId: string): Promise<boolean> => {
    await new Promise(resolve => setTimeout(resolve, 200));
    const companyIndex = mockCompanies.findIndex(company => company.id === companyId);
    if (companyIndex !== -1) {
      mockCompanies[companyIndex].isWatching = false;
      return true;
    }
    return false;
  },

  // Buscar empresa por ID
  getCompanyById: async (companyId: string): Promise<Company | null> => {
    await new Promise(resolve => setTimeout(resolve, 100));
    return mockCompanies.find(company => company.id === companyId) || null;
  },

  // Buscar empresas por nome ou símbolo
  searchCompanies: async (query: string): Promise<Company[]> => {
    await new Promise(resolve => setTimeout(resolve, 300));
    const lowerQuery = query.toLowerCase();
    return mockCompanies.filter(company => 
      company.name.toLowerCase().includes(lowerQuery) ||
      company.symbol.toLowerCase().includes(lowerQuery)
    );
  }
};

